import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ['modal', 'backdrop', 'close'];

    connect() {
        this.element.addEventListener('click', (event) => this.toggle(event));
        this.closeTarget.addEventListener('click', (event) => this.toggle(event));
        this.backdropTarget.addEventListener('click', (event) => this.toggle(event));
    }

    toggle(event) {
        event.preventDefault();
        event.stopPropagation();

        const isOpen = this.modalTarget.classList.contains('is-open');

        this.modalTarget.classList.toggle('is-open');

        if (isOpen) {
            window.lenis.start();
        } else {
            window.lenis.stop();
        }
    }
}
